import { Download } from "lucide-react";
import { use } from "react";
import { useTranslation } from "react-i18next";

import Folder from "@/assets/common/other_icons/folder.svg?react";
import { UserContext } from "@/contexts";
import useSegmentEvent from "@/hooks/useSegmentEvent";

import BaseCard, { ActionButton } from "./BaseCard";

type DownloadPdfProps = {
  scopesBegesUrl?: string;
  scopesGhgUrl?: string;
  pdfRestitutionUrl?: string;
  trajectoriesUrl?: string;
};

function DownloadButton({
  url,
  text,
  segmentEventName,
}: {
  url?: string;
  text: string;
  segmentEventName: string;
}) {
  const { sendSegmentEvent } = useSegmentEvent();

  return (
    <ActionButton
      to={url}
      className="mt-0 whitespace-nowrap"
      onClick={() => sendSegmentEvent(segmentEventName)}
    >
      <Download />
      {text}
    </ActionButton>
  );
}

function Analyses({
  scopesBegesUrl,
  scopesGhgUrl,
  pdfRestitutionUrl,
  trajectoriesUrl,
}: DownloadPdfProps) {
  const { t } = useTranslation("communicate");
  const { user } = use(UserContext);
  const isFreeTrial = user?.company.subscriptionType === "start";

  return (
    <BaseCard
      title={t("analyses.title")}
      text={t("analyses.text")}
      Icon={Folder}
      showNewTag
    >
      <div className="mt-sm gap-2xs flex flex-col flex-wrap items-start lg:flex-row lg:items-center">
        {(pdfRestitutionUrl || isFreeTrial) && (
          <DownloadButton
            url={pdfRestitutionUrl}
            text={t("analyses.format.pdf")}
            segmentEventName="pdf_restitution_downloaded"
          />
        )}
        {(trajectoriesUrl || isFreeTrial) && (
          <DownloadButton
            url={trajectoriesUrl}
            text={t("analyses.format.pdfActionPlan")}
            segmentEventName="pdf_action_plan_downloaded"
          />
        )}
        {(scopesGhgUrl || isFreeTrial) && (
          <DownloadButton
            url={scopesGhgUrl}
            text={t("analyses.format.ghg")}
            segmentEventName="ghg_export_downloaded"
          />
        )}
        {(scopesBegesUrl || isFreeTrial) && (
          <DownloadButton
            url={scopesBegesUrl}
            text={t("analyses.format.beges")}
            segmentEventName="beges_export_downloaded"
          />
        )}
      </div>
    </BaseCard>
  );
}

export default Analyses;
